import { XMarkIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import type { CartItem } from 'lib/burokshop/types';
import { useCart } from './cart-context';

export function DeleteItemButton({ item }: { item: CartItem }) {
  const { updateCartItem } = useCart();
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateCartItem(item.merchandise.id, 'delete');
    } catch (error) {
      console.error('Error removing cart item:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleClick}>
      <button
        type="submit"
        disabled={loading}
        aria-label="Remove cart item"
        className="flex h-[24px] w-[24px] items-center justify-center rounded-full bg-neutral-500 disabled:opacity-50"
      >
        <XMarkIcon className="mx-[1px] h-4 w-4 text-white dark:text-black" />
      </button>
    </form>
  );
}



